import { render, staticRenderFns } from "./Process.vue?vue&type=template&id=216edd12&scoped=true&"
import script from "./Process.vue?vue&type=script&lang=ts&"
export * from "./Process.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216edd12",
  null
  
)

export default component.exports